export default __webpack_public_path__ + "static/media/36I-102785_-15901_0.005e5140.jpg";